import formatCurrency from "./formatCurrency";

export const filterFriendlyMessage = function(filters, store) {
  const filterMessages = [];
  filters.map(filter => {
    switch (filter.field) {
      case "COUNTRY": {
        // code block
        let countryMessage = "";
        const countryValue = [];
        if (filter.values.length !== 0) {
          filter.values.map(value => {
            countryValue.push(value.replace("_", " "));
          });
        }
        if (filter.operator === "EQUALS") {
          countryMessage = `are located in ${
            filter.values.length !== 0 ? countryValue.join(", ") : ""
          }`;
        } else {
          countryMessage = `are not located in ${
            filter.values.length !== 0 ? countryValue.join(", ") : ""
          }`;
        }
        console.log(countryMessage);
        filterMessages.push(countryMessage);
        break;
      }
      case "ORDERED": {
        // code block
        let orderedMessage = "";
        let orderedValue = "";
        if (Array.isArray(filter.values)) {
          orderedValue = filter.values[0]
            ? filter.values[0]
                .split("_")
                .map(w => w[0].toUpperCase() + w.substr(1).toLowerCase())
                .join(" ")
            : "";
        } else if (filter.values) {
          orderedValue = filter.values
            ? filter.values
                .split("_")
                .map(w => w[0].toUpperCase() + w.substr(1).toLowerCase())
                .join(" ")
            : "";
        } else {
          orderedValue = "";
        }

        if (filter.operator === "EQUALS") {
          orderedMessage = "has placed an order within " + orderedValue;
        } else {
          orderedMessage = "has not place and order within " + orderedValue;
        }
        filterMessages.push(orderedMessage);
        break;
      }
      case "ORDER_COUNT": {
        // code block
        let messageOrderCount = "";
        switch (filter.operator) {
          case "EQUALS":
            messageOrderCount = `have made ${filter.values} orders`;
            filterMessages.push(messageOrderCount);
            break;
          case "NOT_EQUALS":
            messageOrderCount = `have not made ${filter.values} orders`;
            filterMessages.push(messageOrderCount);
            break;
          case "GREATER_THAN":
            messageOrderCount = `have made more than ${filter.values} orders`;
            filterMessages.push(messageOrderCount);
            break;
          case "LESS_THAN":
            messageOrderCount = `have made less than ${filter.values} orders`;
            filterMessages.push(messageOrderCount);
            break;
          case "GREATER_OR_EQUAL_TO":
            messageOrderCount = `have made more than or exactly ${filter.values} orders`;
            filterMessages.push(messageOrderCount);
            break;
          case "LESS_OR_EQUAL_TO":
            messageOrderCount = `have made less than or exactly ${filter.values} orders`;
            filterMessages.push(messageOrderCount);
            break;
          default:
        }
        break;
      }
      case "TOTAL_SPENT": {
        // code block
        let messageTotalSpent = "";
        const valueTotalSpent = formatCurrency(
          filter.values,
          store.primaryLocale + "-" + store.countryCode,
          store.primaryCurrencyCode
        );

        switch (filter.operator) {
          case "EQUALS":
            messageTotalSpent = `have spent ${valueTotalSpent}`;
            filterMessages.push(messageTotalSpent);
            break;
          case "NOT_EQUALS":
            messageTotalSpent = `have not spent ${valueTotalSpent}`;
            filterMessages.push(messageTotalSpent);
            break;
          case "GREATER_THAN":
            messageTotalSpent = `have spent more than ${valueTotalSpent}`;
            filterMessages.push(messageTotalSpent);
            break;
          case "LESS_THAN":
            messageTotalSpent = `have spent less than ${valueTotalSpent}`;
            filterMessages.push(messageTotalSpent);
            break;
          case "GREATER_OR_EQUAL_TO":
            messageTotalSpent = `have spent more than or exactly ${valueTotalSpent}`;
            filterMessages.push(messageTotalSpent);
            break;
          case "LESS_OR_EQUAL_TO":
            messageTotalSpent = `have spent less than or exactly ${valueTotalSpent}`;
            filterMessages.push(messageTotalSpent);
            break;
          default:
        }
        break;
      }
      case "TAG": {
        // code block
        let tagMessage = "";
        if (filter.operator === "EQUALS") {
          tagMessage =
            (filter.values.length !== 1
              ? "customers that have the tags "
              : "customers that have the tag ") +
            (filter.values.length !== 0 ? filter.values.join(", ") : "");
        } else {
          tagMessage =
            (filter.values.length !== 1
              ? "customers that do not have the tags "
              : "customers that do not have the tag ") +
            (filter.values.length !== 0 ? filter.values.join(", ") : "");
        }
        filterMessages.push(tagMessage);
        break;
      }
      default:
      // code block
    }
  });
  return filterMessages;
};
